module.exports = __webpack_public_path__ + "static/media/1xBlock_2.362a38d0.png";